import { privateGateway } from '../../../config';

export const storeLoginActivity = async (): Promise<void> => {
  await privateGateway(
    process.env.REACT_APP_USER_CONTROLLER_API_GATEWAY as string
  ).post(`/users/signin/callback`);
};
